module.exports = __webpack_public_path__ + "img/20190628160741830.db874f8a.png";